import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home';
import { EventsComponent } from './features/events/events';
import { CoursesComponent } from './features/courses/courses';
import { MembershipComponent } from './features/membership/membership';
import { ContactComponent } from './features/contact/contact';

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'events', component: EventsComponent },
    { path: 'courses', component: CoursesComponent },
    { path: 'membership', component: MembershipComponent },
    { path: 'contact', component: ContactComponent },
    { path: 'admin', loadChildren: () => import('./admin/admin.routes').then(m => m.adminRoutes) },
];
